"use strict";
var random = require("../core/random");
/**
 * Generates randomized date time ISO format string.
 *
 * @returns {string}
 */
function dateTimeGenerator() {
    return new Date(random.number(0, 100000000000000)).toISOString();
}
module.exports = dateTimeGenerator;



//////////////////
// WEBPACK FOOTER
// ./~/json-schema-faker/lib/generators/dateTime.js
// module id = 1326
// module chunks = 1